<div class="modal fade" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header mb-3">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="container text-center">
				<ul class="list-inline">
					<li class="list-inline-item" *ngFor="let item of tableColumns">
						<button
							mat-raised-button
							class="mb-2"
							*ngIf="item.name"
							[color]="settings.hiddenColumns.includes(item.id) ? 'basic' : 'primary'"
							(click)="showHideRow(item.id)"
						>
							{{ item.name }}
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>

<mat-table #dataTable [dataSource]="matData" matSort matSortDirection="asc" class="mat-elevation-z4">
	<ng-container *ngFor="let item of tableColumns" [matColumnDef]="item.id">
		<mat-header-cell class="custom-header" *matHeaderCellDef mat-sort-header>
			{{ item.name }}
		</mat-header-cell>
		<span
			><mat-cell *matCellDef="let element"
				><span *ngIf="!element[item.id]?.isLink">{{ element[item.id] }}</span
				><a [href]="element[item.id]?.route" *ngIf="element[item.id]?.isLink" target="_blank">{{
					element[item.id].label
				}}</a></mat-cell
			></span
		>
	</ng-container>
	<ng-container matColumnDef="editButton">
		<mat-header-cell *matHeaderCellDef> </mat-header-cell>
		<mat-cell *matCellDef="let element">
			<button class="mat-custom-editButton" mat-raised-button>>></button></mat-cell
		>
	</ng-container>
	<ng-container matColumnDef="columnShow">
		<mat-header-cell *matHeaderCellDef
			><button mat-icon-button [matMenuTriggerFor]="option">
				<i class="fa-solid fa-ellipsis-vertical"></i>
			</button>
			<mat-menu class="custom-mat-menu" #option="matMenu">
				<button mat-menu-item (click)="openDialog()">Widok kolumn<i class="fas fa-eye ms-2"></i></button>
				<button mat-menu-item (click)="copy2Clipboard()">Skopiuj<i class="fas fa-clipboard ms-2"></i></button>
			</mat-menu>
		</mat-header-cell>
		<mat-cell *matCellDef="let element"></mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="showColumns" class="mat-header-custom"></mat-header-row>
	<mat-row *matRowDef="let row; columns: showColumns; let i = index" [ngClass]="{ second: !(i % 2) }"></mat-row>
</mat-table>

<div class="mat-elevation-z4 text-center py-5" *ngIf="matData.data.length === 0">Brak wyników</div>

<mat-paginator class="mat-elevation-z4" [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons> </mat-paginator>
